import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { config } from '../../../utils/config';
import Counter from '../../common/Counter';
import { convertToUtcTimeSS } from '../../../utils/timeConversion';


export default function ListingDetails(props) {

  const [data, setData] = useState(null)


  useEffect(() => {

    const getFullListingData = async () => {

      const response = await axios.get(`${config.apiBaseUrl}/bidsession/listing`, {
        params: {
          bidId: props.id
        }
      })
      console.log("this is listingData", response.data)
      setData(response.data)
    }

    getFullListingData()



  }, [props.id])

  return (
    <>

      {data ? <div className="container-fluid">
        <div className="row content">
          <div className="col-sm-4 hidden-xs">
            <img src={data.listingDetails.media[0].media_url} className="img-fluid" alt="..." />
          </div>
          <br />

          <div className="col-sm-8">
            <div className="well">
              <h4>{data.listingDetails.propertyDetails.project_name && data.listingDetails.propertyDetails.project_name!== "Nil" ? 
              data.listingDetails.propertyDetails.project_name : data.listingDetails.propertyDetails.street_name}</h4>
              <p>{data.listingDetails.propertyDetails.block} {data.listingDetails.propertyDetails.street_name} {data.listingDetails.unit} Singapore
                {" " + data.listingDetails.propertyDetails.postal_code}</p>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="well">
                  <h5>{data.listingDetails.listing_type}</h5>
                  <p>{data.listingDetails.listing_sub_type}</p>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="well">
                  <h5>{data.bid_type}</h5>
                  {data.bidSettings ? <p>Starting Bid {data.bidSettings.opening_bid}</p> : null}
                </div>
              </div>
              <div className="col-sm-2">
                <div className="well">
                  <h5>Ending In</h5>
                  {/* <p>10 Million</p> */}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="well">
                  <h5 className="text-danger"><Counter dateTime={convertToUtcTimeSS(data.end_time)} /></h5>
                  {/* <p>30%</p> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="well">
                  <h5>Bidding Deposit</h5>
                  <p>${data.deposit}</p>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="well">
                  <h5>Expected Completion</h5>
                  {data.bidSettings ? <p>Starting Bid {data.bidSettings.opening_bid}</p> : null}
                </div>
              </div>
              <div className="col-sm-3">
                <div className="well">
                  <h5>S&P Deposit</h5>
                  <p>5%</p>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="well">
                  <h5>Download COS</h5>
                  {/* <p>30%</p> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="well">
                  <p>Bidding Deposit</p>
                  <p>info 2</p>
                  <p>info 3</p>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="well">
                  <p>This can be property detail</p>
                  <p>info 5</p>
                  <p>info 6</p>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="well">
                  <p>info 7</p>
                  <p>info 8</p>
                  <p>info 9</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <div className="well">
                  <p>this is col-sm-8 Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nulla facere a accusantium recusandae quaerat culpa cumque optio. Atque, tenetur incidunt error ullam veritatis voluptate velit vel ad rem, tempora excepturi.</p>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="well">
                  <p>This is col-sm-4. This can be agent information</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> :

        null
      }


    </>
  )
}

